import {
  DEPRECATED_backwardsCompatibleValues,
  StrictLocalizeFunction,
} from "@faire/web/common/localization/localize";
import isUndefined from "lodash/isUndefined";

export const getLeadTimeText = (
  lowerBoundDays: number | undefined,
  upperBoundDays: number | undefined,
  strictLocalize: StrictLocalizeFunction
) => {
  if (isUndefined(lowerBoundDays) || isUndefined(upperBoundDays)) {
    return undefined;
  }

  if (lowerBoundDays === upperBoundDays || lowerBoundDays === 0) {
    return strictLocalize(
      {
        id: "aCc3NP",
        defaultMessage:
          "{count, plural, one {Ships in # day} other {Ships in # days}}",
        description: {
          text: "Shipping window in days",
        },
      },
      DEPRECATED_backwardsCompatibleValues({
        count: upperBoundDays,
      })
    );
  }

  return strictLocalize(
    {
      id: "KuJevU",
      defaultMessage: "Ships within {lower}-{upper} days",
      description: {
        text: "Shipping window in days",
      },
    },
    DEPRECATED_backwardsCompatibleValues({
      lower: lowerBoundDays,
      upper: upperBoundDays,
    })
  );
};
